import { fmhAPI, OPPORTUNITY_CURATOR_API_URL } from 'api/APIBase';

// Fixinator Endpoints:
export async function findOpportunities({
    body = undefined,
    page = undefined,
    dateFilter = undefined,
    searchTerm = undefined,
}) {
    const url = `${OPPORTUNITY_CURATOR_API_URL}/fixinator/opportunities/list`;
    return fmhAPI.base
        .url(url)
        .query({
            ...(page == null ? {} : { page }),
            ...(dateFilter == null ? {} : { date_filter: dateFilter }),
            ...(searchTerm == null ? {} : { search_term: searchTerm }),
        })
        .post(body)
        .json();
}

export async function getOpportunity(referralId) {
    const url = `${OPPORTUNITY_CURATOR_API_URL}/fixinator/opportunities/${referralId}`;
    return fmhAPI.base.url(url).get().json();
}

/** Fix an invalid referral */
export async function fixInvalidReferralOpportunity({
    referralId,
    prescriberNpi,
    placeOfService,
    benefit,
    memberAddress1,
    memberCity,
    memberState,
    memberZip,
    waitForClaim,
}) {
    const url = `${OPPORTUNITY_CURATOR_API_URL}/fixinator/opportunities/${referralId}`;
    return fmhAPI.base
        .url(url)
        .post({
            patient_address_1: memberAddress1,
            patient_city: memberCity,
            patient_state: memberState,
            patient_zip: memberZip,
            prescriber_npi: prescriberNpi,
            place_of_service: placeOfService,
            wait_for_claim: waitForClaim,
            benefit,
        })
        .json();
}
